import React, { useEffect, useState } from "react";
import { Breadcrumbs } from "../../AbstractElements";
import { Button, Col, Container, Row } from "reactstrap";
import axios from "axios";
import { BLOGS_API } from "../../api";
import CardSkeleton from "../Common/Component/CardSkeleton";
import AddBlog from "./AddBlog";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogs } from "../../slices/blogSlice";
import { queryClient } from "../../api/queryClient";
import ConfirmationAlert from "../Common/Component/ConfirmationAlert";
import { toasterConfig } from "../../utils";
import Swal from "sweetalert2";

const Blog = () => {
  const [showAddBlog, setShowAddBlog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [blogDataToEdit, setBlogDataToEdit] = useState();
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const blogId = "";
  const blogTitle = "";

  const dispatch = useDispatch();
  const {
    data: blogs,
    loading,
  } = useSelector((state) => {
    return state.blogs.blogs;
  });

  useEffect(() => {
    dispatch(fetchBlogs());
  }, [dispatch]);

  const editBlog = (data) => {
    setBlogDataToEdit(data);
    setIsEditMode(true);
    setShowAddBlog(true);
  };

  // const deleteBlogData = async (id) => {
  //   try {
  //     const response = await axios.delete(`${BLOGS_API}?blogID=${id}`);
  //     if (response) {
  //       dispatch(fetchBlogs());
  //       toasterConfig("success", "Blog deleted successfully");
  //       setIsDeleteConfirmOpen(false);
  //     }
  //   } catch (error) {
  //     console.error("Error deleting blog:", error);
  //   }
  // };

  const deleteBlogData = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this blog?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#fc4438",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.delete(`${BLOGS_API}?blogID=${id}`);
          if (response) {
            toasterConfig(
              "success",
              response.data?.message || "Deleted successfully"
            );
            queryClient.removeQueries({ queryKey: ["blogs"] });
            dispatch(fetchBlogs(true)); // Refresh the list
          } else {
            toasterConfig("error", "Something went wrong");
          }
        } catch (error) {
          toasterConfig("error", "Something went wrong");
        }
      }
    });
  };

  return (
    <>
      {!showAddBlog ? (
        <>
          <Breadcrumbs
            mainTitle={"Blogs"}
            buttonTitle={"Add Blog"}
            onClick={() => {
              setIsEditMode(false);
              setShowAddBlog(true);
            }}
          />

          <Container fluid={true}>
            <Row className="widget-grid">
              {loading ? (
                <CardSkeleton />
              ) : (
                <>
                  {blogs?.length > 0 &&
                    blogs?.map((blog) => (
                      <Col
                        lg="4"
                        md="4"
                        sm="12"
                        xs="12"
                        key={blog.blogID}
                        className="mb-3"
                      >
                        <div className="card">
                          <img
                            src={blog.postThumbnail}
                            className="card-img-top p-2 rounded-4"
                            alt="Blog"
                            style={{ height: "150px", objectFit: "cover" }}
                          />
                          <div className="card-body p-4">
                            <h5
                              className="card-title"
                              style={{
                                display: "inline-block",
                                maxWidth: "100%",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                verticalAlign: "bottom",
                              }}
                              title={blog.title}
                            >
                              {blog.title}
                            </h5>
                            <div
                              className="card-text f-12"
                              style={{
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxHeight: "5em",
                              }}
                            >
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: blog.blogContent,
                                }}
                              />
                            </div>
                            <span className="text-info f-12">Read more...</span>
                            <div className="d-flex">
                              <Button
                                color="primary"
                                className="me-2"
                                onClick={() => editBlog(blog)}
                              >
                                Edit
                              </Button>
                              <Button
                                color="secondary"
                                onClick={() => {
                                  deleteBlogData(blog.blogID);
                                }}
                              >
                                Delete
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Col>
                    ))}
                </>
              )}
            </Row>
          </Container>
        </>
      ) : (
        <AddBlog
          onClose={() => setShowAddBlog(false)}
          isEditMode={isEditMode}
          blogDataToEdit={blogDataToEdit}
        />
      )}
      <ConfirmationAlert
        isOpen={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        handleConfirm={() => deleteBlogData(blogId)}
        title={blogTitle}
      />
    </>
  );
};

export default Blog;
